import $ from 'jquery';
import dialogPolyfill from 'dialog-polyfill';
import * as bodyScrollLock from 'body-scroll-lock/lib/bodyScrollLock';

/**
 * @desc Shows localization preferences.
 */
export default class LocaleSelector {
  /**
   * @param {Object} options
   * @param {string} options.localeSelectorSelector
   * @param {string} options.localeModalSelector
   * @param {string} options.closeLocaleModalSelector
   */
  constructor({ localeSelectorSelector, localeModalSelector, closeLocaleModalSelector } = {}) {
    this.$localeSelector = $(localeSelectorSelector);
    this.$localeModal = $(localeModalSelector);
    this.$buttonCloseLocaleModal = $(closeLocaleModalSelector);

    this.init();
  }

  init() {
    this.isInitialized = true;

    if (
      !this.$localeSelector.length
      || !this.$localeModal.length
      || !this.$buttonCloseLocaleModal.length
    ) {
      this.isInitialized = false;

      return;
    }

    dialogPolyfill.registerDialog(this.$localeModal[0]);

    this.attachEventListeners();
  }

  attachEventListeners() {
    this.$localeSelector.click(() => this.open());

    this.$buttonCloseLocaleModal.click(() => this.close());

    this.$localeModal[0].addEventListener('close', () => {
      bodyScrollLock.enableBodyScroll(this.$localeModal[0]);

      this.$localeModal.scrollTop(0);
    });
  }

  open() {
    this.$localeModal[0].showModal();

    $(document.activeElement).blur();

    bodyScrollLock.disableBodyScroll(this.$localeModal[0]);
  }

  close() {
    this.$localeModal[0].close();
  }
}
